import React, { useRef } from 'react';

import Colors from 'pubweb-smokey/dist/colors';
import PropTypes from 'prop-types';
import RadioButtonStyles from './RadioButton.styled';

const RadioButton = React.forwardRef(function RadioButton(
  {
    label,
    id,
    disabled,
    primaryColor = Colors.primary.claytonBlue,
    checked,
    name,
    value,
    automationId,
    className,
    onChange = () => {},
    ...props
  },
  ref
) {
  const propertyClasses = [];
  const inputEl = useRef(null);
  const radioRef = ref || inputEl;
  const labelRef = useRef();

  propertyClasses.push(primaryColor.className);
  propertyClasses.push(disabled ? 'disabled' : '');

  return (
    <RadioButtonStyles className={className + ' ' + propertyClasses.join(' ')}>
      <label
        ref={labelRef}
        htmlFor={id}
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            if (radioRef.current) {
              radioRef.current.checked = true;
            }

            //forceUpdate();
            if (props.onChange) {
              props.onChange({ target: radioRef.current });
            }
            e.preventDefault();
            e.stopPropagation();
          }
        }}
      >
        <input
          ref={radioRef}
          tabIndex="-1"
          onFocus={() => labelRef.current.focus()}
          disabled={disabled}
          className="form-radio"
          id={id}
          name={name}
          data-test-id={automationId || null}
          type="radio"
          value={value}
          checked={checked}
          onChange={onChange}
          {...props}
        />
        <span>{label}</span>
      </label>
    </RadioButtonStyles>
  );
});

RadioButton.defaultProps = {
  label: '',
  id: '',
  disabled: false,
  checked: false,
  name: '',
  value: '',
  automationId: '',
  className: '',
};

RadioButton.propTypes = {
  automationId: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.any,
  name: PropTypes.string,
  onChange: PropTypes.func,
  primaryColor: PropTypes.shape({
    className: PropTypes.any,
  }),
  value: PropTypes.any,
};

export default RadioButton;
